import React, { useEffect, useMemo, useState } from "react";
import "./dashboard.scss";
import { getDashboard } from "../../api/crawlerApi";

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return Number(value).toLocaleString();
};

const DashboardPage = () => {
  const [data, setData] = useState({ summary: {}, top_high_score_opportunities: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    getDashboard()
      .then((response) => {
        if (!active) return;
        setData(response);
      })
      .catch((err) => {
        if (!active) return;
        setError(err.message || "Failed to load dashboard.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const stats = useMemo(() => {
    const summary = data.summary || {};

    return [
      { label: "Total Leads", value: formatValue(summary.total_leads), icon: "♙", tone: "red" },
      { label: "New Leads", value: formatValue(summary.new_leads), icon: "▤", tone: "yellow" },
      { label: "High Score Leads", value: formatValue(summary.high_score_leads), icon: "↗", tone: "green" },
    ];
  }, [data.summary]);

  const topLeads = data.top_high_score_opportunities || [];

  return (
    <div className="dashboard-page">
      <section className="dashboard-page__hero">
        <div>
          <h2>Welcome back, Admin! 👋</h2>
          <p>Here’s what’s happening with your crawler pipeline right now.</p>
        </div>
      </section>

      {error && <div className="dashboard-page__panel">{error}</div>}

      <section className="dashboard-page__stats">
        {stats.map((item) => (
          <article className="dashboard-page__stat-card" key={item.label}>
            <div className={`dashboard-page__stat-icon dashboard-page__stat-icon--${item.tone}`}>
              {item.icon}
            </div>
            <div>
              <p>{item.label}</p>
              <h3>{loading ? "..." : item.value}</h3>
            </div>
          </article>
        ))}
      </section>

      <section className="dashboard-page__bottom-grid">
        <article className="dashboard-page__panel">
          <div className="dashboard-page__panel-header">
            <h3>Top Opportunities</h3>
          </div>
          <div className="dashboard-page__table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Project</th>
                  <th>Developer</th>
                  <th>Source</th>
                  <th>State</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                {topLeads.length === 0 ? (
                  <tr>
                    <td colSpan="5">{loading ? "Loading..." : "No records found."}</td>
                  </tr>
                ) : (
                  topLeads.map((lead) => (
                    <tr key={lead.id}>
                      <td>{lead.project_name}</td>
                      <td>{lead.developer || "-"}</td>
                      <td>{lead.source || "-"}</td>
                      <td>{lead.state || "-"}</td>
                      <td>
                        <span className={`dashboard-page__status dashboard-page__status--new`}>
                          {lead.lead_score ?? 0}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </article>
      </section>
    </div>
  );
};

export default DashboardPage;
